{
  "version": 1,
  "asset_id": "fbca15a6-e41e-4c1a-aee7-53428852e976",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/fbca15a6-e41e-4c1a-aee7-53428852e976/clip-img_2096.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/fbca15a6-e41e-4c1a-aee7-53428852e976/clip-img_2096.mp4",
  "original_filename": "clip-img_2096.mp4",
  "size": 366014,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:32:42Z"
}
